import SwitcherWithText from './SwitcherWithText';

export default SwitcherWithText;
